import { createSelector } from 'reselect';
import { careerAndSeasonStatsSelector } from './simple-selectors';

export const careerAndSeasonStatsSortSelector = createSelector(
    careerAndSeasonStatsSelector,
    (careerAndSeasonStats) => careerAndSeasonStats.sort
);
